import React, {useState, useEffect} from 'react';
import './style.css';
import { useNavigate } from 'react-router-dom';
import ContentHeading from '../../components/contentHeading/contentHeading';
import ContentHeadingButton from '../../components/contentHeading/contentHeadingButton';
import TableView from '../../components/tableView/tableView';
import { authFetch } from '../../components/authFetch/authFetch'
import { Throbber } from '../../components/throbber/throbber'
import { SlEnvolope } from "react-icons/sl";
import { Link } from 'react-router-dom';

const Audience = () => {
    const navigate = useNavigate();
    const [segments, setSegments] = useState([]);
    const [statusState, setStatusState] = useState('loading');

    const headings = {
        Segment: 'Segment',
        Type: 'Type',
        Contacts: 'Contacts',
        LastUpdated: 'Last Updated',
    };

    const formatSegmentData = (data) => {
        console.log(data)
        if (!data || !Array.isArray(data)) {
            console.error("formatSegmentData received invalid data:", data);
            return [];
        }

        return data.map((segment) => ({
            Segment: <Link to={`/segment/detail?id=${segment.id}`} style={{ color: "black"}}>{segment.name}</Link>,
            Type: segment.type || "N/A",
            Contacts: segment.contact_count || "N/A",
            LastUpdated: segment.last_updated
                ? new Date(segment.last_updated).toLocaleDateString() 
                : "N/A",
        }));
    };

    useEffect(() => {
        authFetch({
            apiMethod: "GET",
            endpoint: "/audience/segments",
            onDataLoaded: (data) => {
                setStatusState("success")
                setSegments(formatSegmentData(data?.segments))
            },
            onErrorResponse: (data) => {
                setStatusState("error");
                console.log("error");
            }
        });
    }, []);

    return (
        <div className='audience-home-container'>
            {statusState == "loading" && (
                <div className="throbber-overlay">
                    <Throbber />
                </div>
            )}

            <ContentHeading heading="Segments" />

            <TableView headings={headings} data={segments}/>
        </div>
    );
};

export { Audience };
